import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  useNavigate,
} from "react-router-dom";

// plugins styles from node_modules
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "select2/dist/css/select2.min.css";
import "quill/dist/quill.core.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
// plugins styles downloaded
import "assets/vendor/nucleo/css/nucleo.css";
// core styles
import "assets/scss/argon-dashboard-pro-react.scss?v1.2.1";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import { Provider } from "react-redux";
import { reducers } from "reducers";
import { configureStore } from "@reduxjs/toolkit";
import { ROLES } from "components/CommonComponents/Constant";
import ResetPassword from "pages/Auth/ResetPassword";

const root = ReactDOM.createRoot(document.getElementById("root"));
const store = configureStore({ reducer: reducers });
export default store;

const App = () => {
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("p"))?.token;
  const role = JSON.parse(localStorage.getItem("p"))?.role;

  // useEffect(() => {
  //   if (!token) navigate("/auth/login");
  // }, []);

  React.useEffect(() => {
    //added this code for if the sub-user comes on this routs then we will navigate it back to dashboard
    //as of new role is Introduced so added a condition to make the /configuration and email/configuration route available
    const protectedRoutes =
      role === ROLES.salesPerson
        ? ["/admin/plans/edit", "/admin/add/user"]
        : [];
    // Check if the current path contains one of the public paths
    //check condition if the user role is not Admin and in local have token and user try to goes on path which is not accessible
    //It navigate the user to the dashboard
    if (
      role !== ROLES.superAdmin &&
      token &&
      protectedRoutes?.some((path) => window.location.pathname.includes(path))
    ) {
      navigate("admin/dashboard");
    }
  }, [role, window.location.pathname]);

  return (
    <Routes>
      <Route path="/admin/*" element={<AdminLayout />} />
      <Route path="/auth/*" element={<AuthLayout />} />
      <Route path="/user-reset-password/*" element={<ResetPassword />} />
      <Route path="*" element={<Navigate to="/auth/login" replace />} />
    </Routes>
  );
};

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
